import React from 'react'
import { ATLDialog } from '@appsimples/atlantica-react-native'
import { Platform } from 'react-native'

const isWeb = Platform.OS === 'web'
let ModalWeb
if (isWeb) {
  const { ModalWeb: loadedModalWeb } = require('../../../components/ModalWeb')
  ModalWeb = loadedModalWeb
}

export const Modal: React.FC<any> = props => {
  return isWeb ? <ModalWeb {...props} /> : <ATLDialog {...props} />
}
